const authService = require("./auth");

async function onboard(bodyObject) {
    //headers
    var headers = new Headers();
    headers.append("Content-Type", "application/json");
    headers.append("Accept", "application/json");
    headers.append("Authorization", `Bearer ${await authService.authFront()}`);
    //Body
    var raw = JSON.stringify(bodyObject);

    var requestOptions = {
        method: 'POST',
        headers: headers,
        body: raw
    };

    const req = await fetch(`${process.env.API_URL}/onboard/${bodyObject.selTipo}/locate`.toLowerCase(), requestOptions)

    return req;

}

async function donation(bodyObject, userID) {
    //headers
    var headers = new Headers();
    headers.append("Accept", "application/json");
    headers.append("Authorization", `Bearer ${await authService.authFront()}`);

    //Body
    var raw = bodyObject;

    var requestOptions = {
        method: 'POST',
        headers: headers,
        body: raw
    };

    const req = await fetch(`${process.env.API_URL}/onboard/donation/${userID}`.toLowerCase(), requestOptions)

    return req;

}

async function request(bodyObject, userID) {
    //headers
    var headers = new Headers();
    headers.append("Accept", "application/json");
    headers.append("Authorization", `Bearer ${await authService.authFront()}`);

    //Body
    var raw = bodyObject;

    var requestOptions = {
        method: 'POST',
        headers: headers,
        body: raw
    };

    const req = await fetch(`${process.env.API_URL}/onboard/request/${userID}`.toLowerCase(), requestOptions)

    return req;

}


async function withdraw(bodyObject, userID) {
    //headers
    var headers = new Headers();
    headers.append("Accept", "application/json");
    headers.append("Authorization", `Bearer ${await authService.authFront()}`);

    //Body
    var raw = bodyObject;

    var requestOptions = {
        method: 'POST',
        headers: headers,
        body: raw
    };

    const req = await fetch(`${process.env.API_URL}/onboard/withdraw/${userID}`.toLowerCase(), requestOptions)

    return req.json();

}

/**
 * Create user object by type and creturns created user.
 *
 * @param {string} type pf, pj, ong.
 * @return {object} user object.
 */
async function register(type_id, bodyObject) {
    //headers
    var headers = new Headers();
    headers.append("Accept", "application/json");
    headers.append("Authorization", `Bearer ${await authService.authFront()}`);

    //Body
    var raw = bodyObject;

    var requestOptions = {
        method: 'POST',
        headers: headers,
        body: raw
    };

    const req = await fetch(`${process.env.API_URL}/onboard/${type_id}/register`.toLocaleLowerCase(), requestOptions)

    return req;

}


/**
 * save entity profile.
 *
 * @param {string} bodyObject bodyObject of request.
 * @return {object} req.
 */
async function saveProfile(entity_id, bodyObject) {
    // alert(`entity_id ${entity_id}`)
    //headers
    var headers = new Headers();
    // headers.append("Content-Type", "application/json");
    headers.append("Accept", "application/json");
    headers.append("Authorization", `Bearer ${await authService.authFront()}`);

    //Body

    var requestOptions = {
        method: 'POST',
        headers: headers,
        body: bodyObject,
        redirect: 'follow'
    };

    const req = await fetch(`${process.env.API_URL}/onboard/save-profile/${entity_id}`, requestOptions)

    return req;

}


/**
 *generate new token.
 *
 * @param {string} entity_id entity_id of user.
 * @return {object} req.
 */
async function generateNewToken(entity_id) {
    //headers
    var headers = new Headers();
    headers.append("Accept", "application/json");
    headers.append("Authorization", `Bearer ${await authService.authFront()}`);

    //Body

    var requestOptions = {
        method: 'POST',
        headers: headers,
         body: {},
        redirect: 'follow'
    };

    const req = await fetch(`${process.env.API_URL}/onboard/new-token/${entity_id}`, requestOptions)

    return req;

}

/**
 * resend Token.
 *
 * @param {string} entity_id entity_id of user.
 * @return {object} req.
 */
 async function resendToken(entity_id) {
    //headers
    var headers = new Headers();
    headers.append("Accept", "application/json");
    headers.append("Authorization", `Bearer ${await authService.authFront()}`);

    //Body

    var requestOptions = {
        method: 'POST',
        headers: headers,
         body: {},
        redirect: 'follow'
    };

    const req = await fetch(`${process.env.API_URL}/onboard/resend-token/${entity_id}`, requestOptions)

    return req;

}



/**
 * verify token
 *
 * @param {string} entity_id entity_id of user.
 * @return {object} req.
 */
async function verifytoken(entity_id,token) {
    //headers
    var headers = new Headers();
    headers.append("Content-Type", "application/json");
    headers.append("Accept", "application/json");
    headers.append("Authorization", `Bearer ${await authService.authFront()}`);

    //Body

    var requestOptions = {
        method: 'POST',
        headers: headers,
        body: JSON.stringify({
          "terms": true,
          "token": token
        }),
        redirect: 'follow'
    };

    const req = await fetch(`${process.env.API_URL}/onboard/verify/${entity_id}`, requestOptions)

    return req;

}


// /onboard/verify/{entity_id}

module.exports = {
    onboard: onboard,
    register: register,
    register: register,
    withdraw: withdraw,
    request: request,
    donation: donation,
    saveProfile: saveProfile,
    generateNewToken: generateNewToken,
    verifytoken: verifytoken,
    resendToken: resendToken
}
